import lf from 'lovefield'

export function simuexo_mouvements (schemaBuilder) {
  schemaBuilder.createTable('simuexo_mouvements')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('code', lf.Type.STRING)
      .addColumn('exo_chantiers_id', lf.Type.INTEGER)
      .addColumn('simuexo_cubatures_depart_id', lf.Type.INTEGER)
      .addColumn('simuexo_cubatures_couches_depart_id', lf.Type.INTEGER)
      //.addColumn('cubatureDepartCouche', lf.Type.INTEGER)
      .addColumn('simuexo_cubatures_arrivee_id', lf.Type.INTEGER)
      .addColumn('simuexo_cubatures_couches_arrivee_id', lf.Type.INTEGER)
      //.addColumn('cubatureArriveeCouche', lf.Type.INTEGER)
      .addColumn('volume', lf.Type.INTEGER)
      .addColumn('distance', lf.Type.INTEGER)
      .addColumn('const_sol_id', lf.Type.INTEGER)
      .addColumn('preparationtraitementdemande', lf.Type.STRING)
      .addColumn('transformationdemandee', lf.Type.STRING)
      .addColumn('stopautoavant', lf.Type.INTEGER)
      .addColumn('stopautoapres', lf.Type.INTEGER)
      .addColumn('reglage', lf.Type.INTEGER)
      .addColumn('description', lf.Type.STRING)
      .addPrimaryKey(['id'], true) // true == autoincrement
      .addNullable(['code', 'exo_chantiers_id', 'simuexo_cubatures_depart_id', 'simuexo_cubatures_arrivee_id', 'volume', 'distance', 'const_sol_id', 'preparationtraitementdemande', 'transformationdemandee', 'stopautoavant', 'stopautoapres', 'reglage', 'description']);
      // .addUnique('code', ['code'])
}




// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuexoMouvements.schema.js